<template>
  <div class="container">
    <div>
      <el-form :inline="true" :model="planParams" class="demo-form-inline">
        <el-form-item label="毕业年份:">
          <el-select
              clearable
              v-model="planParams.year"
              size="small"
              placeholder="请选择"
              style="width: 100px; margin-right: 20px"
          >
            <el-option
                v-for="(item, index) in yearList"
                :key="index"
                :label="item"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省份:">
          <el-select
              clearable
              v-model="selectProvinceId"
              size="small"
              placeholder="请选择"
              style="width: 150px; margin-right: 20px"
              @change="provinceChange"
              @clear="provinceClear"
          >
            <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务专家:">
          <el-select
              clearable
              filterable
              remote
              reserve-keyword
              v-model="planParams.expertId"
              placeholder="请选择"
              @clear="expertClear"
              :remote-method="remoteExpert"
              size="small"
              style="width: 130px; margin-right: 20px"
          >
            <el-option
                v-for="item in serviceExpertList"
                :key="item.expertId"
                :label="item.expertName"
                :value="item.expertId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="search"
          >查询
          </el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
          :stripe="true"
          :height="tableHeigth"
          :data="planList"
          size="small"
          border
          style="width: 100%; margin-bottom: 15px"
          :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
          :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
            prop="templateName"
            label="模板方案名称"
            width="180"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="性别" width="60">
          <template slot-scope="scope">
            {{ scope.row.sex === 0 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column prop="province" label="所在省份" width="100">
        </el-table-column>
        <el-table-column prop="year" label="毕业年份" width="80">
        </el-table-column>
        <el-table-column prop="admitBatch" label="批次" width="130">
        </el-table-column>
        <el-table-column label="科别类型" width="80">
          <template slot-scope="scope">
            {{ matchDisciplineType(scope.row.disciplineType) }}
          </template>
        </el-table-column>
        <el-table-column label="志愿模式" width="100">
          <template slot-scope="scope">
            {{ matchVolunteerMode(scope.row.voPa) }}
          </template>
        </el-table-column>
        <el-table-column prop="planNum" label="志愿数量" width="80">
        </el-table-column>
        <el-table-column label="高考成绩" width="80">
          <template slot-scope="scope">
            {{ scope.row.adminScore ? scope.row.adminScore : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="expertName" label="服务专家" width="100">
        </el-table-column>
        <el-table-column prop="templateRemarks" label="备注" show-overflow-tooltip>
        </el-table-column>
<!--        <el-table-column prop="createTime" label="设置时间" width="180">-->
<!--        </el-table-column>-->
        <el-table-column label="操作" min-width="130">
          <template slot-scope="scope">

            <el-button
                type="text"
                style="font-size: 14px;"
                @click="viewVolunteerTemplate(scope.row)"
            >查看
            </el-button>
            <el-button
                type="text"
                style="font-size: 14px;"
                @click="updateTemplateNameClick(scope.row)"
            >修改名称
            </el-button>
            <el-button
                type="text"
                style="font-size: 14px;color: #FF3333"
                @click="delTemplatePlan(scope.row, 0)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="pageChange"
          :current-page.sync="planParams.current"
          layout="prev, pager, next"
          :total="planTotal"
          :page-size="planParams.size"
      >
      </el-pagination>
    </div>

    <el-dialog
        title="修改模板名称"
        :visible.sync="showUpdateTemplateNameDialog"
        width="430px"
    >
      <el-form :model="updateTemplateNameParams">
        <el-form-item label="模板名称:" label-width="100px">
          <el-input
              v-model="updateTemplateNameParams.templateName"
              size="small"
              style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板备注:" label-width="100px">
          <el-input
              v-model="updateTemplateNameParams.templateRemarks"
              type="textarea"
              size="small"
              :rows="5"
              style="width: 260px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUpdateTemplateNameDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmUpdateTemplateNameConfirm" size="small">确 定</el-button
        >
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {deleteTemplate, getVolunteerTemplatePlan, updateTemplateName} from "@/api/serviceManagement.js";
import {getProvinceList} from "@/api/index.js";
import {getExpertList} from "@/api/commodityManagement.js";
import lpyMixin from "@/mixin/lpyMixin";

export default {
  mixins: [lpyMixin],
  data() {
    return {
      tableHeightSubtract: 290,
      planParams: {
        size: 20,
        year: null,
        current: 1,
        provinceId: "",
        expertId: "",
        studentName: "",
      },
      planTotal: 0,
      planList: [],
      provinceList: [],
      yearList: [],
      serviceExpertList: [],
      expertParams: {},
      showUpdateTemplateNameDialog: false,
      updateTemplateNameParams: {
        draftId: "",
        templateName: "",
        templateRemarks: ""
      },
      selectProvinceId: ""
    };
  },
  mounted() {
    this.obtainProvinceList()
    this.calculateYear()
    this.obtainExpertList()
    this.obtainVolunteerTemplateList()
  },
  methods: {
    obtainExpertList() {
      getExpertList(this.expertParams).then((res) => {
        this.serviceExpertList = res.data || [];
      });
    },
    expertClear() {
      this.expertParams.keyWord = "";
      this.obtainExpertList();
    },
    //用户查询
    remoteExpert(value) {
      setTimeout(() => {
        this.expertParams.keyWord = value;
        this.obtainExpertList()
      }, 200);
    },
    async obtainProvinceList() {
      await getProvinceList().then((res) => {
        this.provinceList = res.data;
      });
    },
    reset() {
      this.planParams.year = null;
      this.expertId.expertUserId = "";
      this.planParams.remark = "";
      this.planParams.studentName = "";
    },
    calculateYear() {
      let currentYear = new Date().getFullYear();
      for (let i = 3; i > 0; i--) {
        this.yearList.push(currentYear + i);
      }
      for (let i = 0; i < 7; i++) {
        this.yearList.push(currentYear - i);
      }
    },
    obtainVolunteerTemplateList() {
      this.planParams.provinceId = this.selectProvinceId
      getVolunteerTemplatePlan({...this.planParams}).then((res) => {
        if (res.code === 1) {
          this.planTotal = res.data.total;
          this.planList = res.data.records || [];
        }
      });
    },
    search() {
      this.planParams.current = 1;
      this.obtainVolunteerTemplateList()
    },
    provinceChange() {
      let selectProvince = this.provinceList.find(item => item.id === this.selectProvinceId)
      this.expertParams.province = selectProvince.name;
      this.obtainExpertList();
    },
    provinceClear(){
      this.expertParams.province = null;
      this.obtainExpertList();
    },
    matchDisciplineType(type) {
      switch (type) {
        case 0:
          return "不分文理";
        case 1:
          return "理科";
        case 2:
          return "文科";
        case 3:
          return "物理类";
        case 4:
          return "历史类";
      }
    },
    matchVolunteerMode(mode) {
      switch (mode) {
        case 1:
          return "院校志愿";
        case 2:
          return "专业志愿";
        case 3:
          return "专业组志愿";
      }
    },
    pageChange(page) {
      this.planParams.current = page;
      this.obtainVolunteerTemplateList();
    },

    /**
     * 志愿模板查看
     * @param row
     */
    viewVolunteerTemplate(row) {
      let routeData = this.$router.resolve({
        path: "/viewVolunteerPlan",
        query: {
          id: row.studentId,
          idOne: row.oneId,
          draftId: row.draftId,
          batch: row.admitBatch,
        },
      });
      window.open(routeData.href, "_blank");
    },

    updateTemplateNameClick(row) {
      this.updateTemplateNameParams = {
        draftId: row.draftId,
        templateName: row.templateName,
        templateRemarks: row.templateRemarks,
      }
      this.showUpdateTemplateNameDialog = true;
    },

    confirmUpdateTemplateNameConfirm() {
      if (!this.updateTemplateNameParams.templateName) {
        this.$message.warning("请输入模板名称");
        return;
      }
      updateTemplateName(this.updateTemplateNameParams).then(res => {
        if (res.code === 1) {
          this.$message.success("修改成功");
          this.showUpdateTemplateNameDialog = false;
          this.obtainVolunteerTemplateList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    delTemplatePlan(row) {
      this.$confirm("确定要删除该志愿模板吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            deleteTemplate({
              draftId: row.draftId,
            }).then(res => {
              if (res.code === 1) {
                this.$message.success("删除成功");
                this.obtainVolunteerTemplateList();
              } else {
                this.$message.error(res.msg);
              }
            })
          })
          .catch(() => {

          })

    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
}
</style>
